import { connect } from 'react-redux';
import { depositProductSelector } from '@alphapoint/apex-web/lib/redux/selectors/depositWithdrawalSelectors';
import { showSnack } from '@alphapoint/apex-web/lib/redux/actions/snackbarActions';
// eslint-disable-next-line import/no-unresolved
import { getDepositInfoWithOptions } from '@app/redux/actions/depositActions';
import CryptoWalletDepositWorkflowComponent from './CryptoWalletDepositWorkflowComponent';

const mapStateToProps = (state) => ({
  addressList: state.deposit.depositInfo,
  isLoading: state.deposit.isLoading,
  accountProviderId: state.deposit.AccountProviderId,
  product: depositProductSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  showSnack: (text) =>
    dispatch(showSnack({ id: 'depositCopyAddress', text, type: 'success' })),
  generateNewDepositAddress: (productId, accountProviderId) =>
    dispatch(getDepositInfoWithOptions(productId, { accountProviderId, generateNewKey: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CryptoWalletDepositWorkflowComponent);
